import React from "react";

function FlamefireIcon({ fill, ...restProps }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...restProps}
    >
      <path
        d="M9.04 2.052c-.316.092-.466.187-.928.585C5.56 4.841 3.745 8.005 3.2 11.2c-.397 2.329-.209 4.106.616 5.821.459.953.937 1.608 1.75 2.4a8.42 8.42 0 0 0 2.33 1.643 9.439 9.439 0 0 0 9.731-.928c.41-.306 1.231-1.108 1.572-1.536a8.536 8.536 0 0 0 1.604-3.331c.666-2.956-.38-6.713-2.658-9.553-.524-.653-1.004-1.125-1.279-1.257-.616-.296-1.477-.095-1.855.432a7.243 7.243 0 0 0-.38.691c-.3.61-.409.802-.713 1.258-.608.911-1.309 1.57-1.922 1.806-.271.105-.897.148-1.075.074-.157-.065-.348-.284-.449-.516-.316-.725-.235-2.206.21-3.851.064-.234.132-.527.151-.65a1.5 1.5 0 0 0-.854-1.569c-.263-.12-.681-.156-.939-.082m-.666 3.534c-.055.327-.073.656-.073 1.334-.001 1.006.041 1.303.275 1.927.186.495.359.766.726 1.137.537.543 1.126.776 1.958.774 1.206-.002 2.12-.401 3.114-1.358.673-.648 1.159-1.288 1.698-2.234l.281-.494.266.334c.846 1.064 1.628 2.568 1.995 3.838.125.431.249 1.034.312 1.516.064.486.063 1.646-.001 2.06-.369 2.369-2.133 4.376-4.565 5.194a7.528 7.528 0 0 1-4.72 0c-2.205-.742-3.876-2.465-4.434-4.574-.34-1.285-.224-3.189.299-4.917.491-1.618 1.456-3.343 2.617-4.674.158-.183.296-.324.306-.314.01.01-.014.213-.054.451"
        fill-rule="evenodd"
        fill={fill ?? ""}
      />
    </svg>
  );
}
export default FlamefireIcon;
